export default function ValidateLogin(btn) {

  var $container = $(btn).parents('.login-controls');

  if ($(btn).parents('#payment-container') != null && $(btn).parents('#payment-container').length) {
    $container = $(btn).parents('#payment-container');
  }

  var login = $container.find(".login-field input");
  var pass = $container.find(".pass-field input");
  var rememberMe = $container.find(".remember-me input");

  var valid = true;

  if (pass.val() == '') {
    pass.addClass('error');
    valid = false;
  }

  if (login.val() == '') {
    login.addClass('error');
    valid = false;
  }

  if (valid) {
    var obj = {};
    obj.Login = login.val();
    obj.Password = pass.val();
    obj.RememberMe = rememberMe[0].checked;
    $.ajax({
      type: "POST",
      url: "/api/account/signin",
      data: JSON.stringify(obj),
      async: false,
      contentType: "application/json",
      success: function (data, status, xhr) {
        if (data.IsSuccess) {
          if (sessionStorage.getItem('isOpenedModalRecension')) {
            var parent = $("#review-form");
            var title = parent.find("#tbxTopic").val();
            var text = parent.find("#tbxComment").val();
            var startCount = 0;
            var star = parent.find('.star-rating').children()
            star.each(function (i) {
              if (this.className === 'selected') {
                startCount++;
              }
            })
            var reviewObject = { title: title, text: text, starCount: startCount };
            sessionStorage.setItem('reviewObject', JSON.stringify(reviewObject));
          }
          location.reload();
          valid = true;
        }
        else {
          login.addClass('error');
          pass.addClass('error');
          $container.find('#login-error').fadeIn().html(data.Message);
          valid = false;
        }
      }
    });
  }
  return false;
}